var bg = {
  title: 'МЕПП',
  header:{
    home: 'Начало',
    login: 'Вход',
    logout: 'Излез',
    registration: 'Регистрация',
    add: 'Добави',
    forum: 'Форум',
    pets: 'Любимци',
    welcome: 'Здравей, ',
    notifications: 'Известия ',
    contacts: 'Контакти',
    menu: 'Навигация',
    services: 'Услуги',
    logoText: 'Най-добрата грижа за домашните любимци и техните хора!',
    cookies: 'Този сайт използва "бисквитки", за да работи оптимално за Вас.',
    cookiesButton: 'Прочети още',
    cookiesClose: 'Разбрах'
  },
  seo:{
    title: 'Електронният Паспорт На Вашия Домашен Любимец',
    description: 'Софтуер за организиране на всички нужни ветеринарни прегледи за Вашия домашен любимец.'
  },
  statistic:{
    title: 'Статистика за месечни регистрации и плащания',
    users: 'Потребители',
    pets: 'Домашни любимци',
    pay: 'Платени годишни такси',
    months: ["Януари", "Февруари", "Март", "Април", "Май", "Юни", "Юли","Август", "Септември", "Октомври", "Ноември", "Декември"],
    yearStatistic: 'Годишна статистика'
  },
  homePage:{
    servicesTitle: 'Добре дошли в МЕПП - електроният паспорт на Вашия домашен любимец!',
    vets: 'Как да избера най-добрия ветеринарен лекар?',
    vetsMessage: 'Въпросът с избора на личен лекар е сложен, колкото при хората, толкова и при животните. Затова ние Ви предлагаме дълъг списък от регистрирани ветеринарни лекари, от които можете да изберете най-подходящия за грижите за Вашето скъпо същество. Бихте могли да добавите повече от един, като всеки от тях ще има достъп до здравния картон на домашния любимец, за да бъде лечението винаги адекватно и професионално.',
    firstParagraf: 'Само с няколко клика разполагате с пълна информация, така че грижата за домашния любимец никога не е била по-лесна. Бързо и от всяка една точка на света ще имате достъп до здравната карта на най-добрия Ви приятел. МЕПП е тук за да бъде полезен- на Вас като стопанин, на Вашия другар и най-вече на неговите лекуващи лекари. Ако любимецът Ви се загуби или изчезнe МЕПП ще го върне у дома. Достатъчно е той да има чип и да фигурира в базата данни на мрежата ветеринарни лекари, доверили се на платформата. Неговият интуитивен дизайн и мултифункционалност го нареждат сред най-желаните софтуери за домашни любимци!',
    reviewTitle: 'Прегледи',
    reviewMessage: 'Всички знаем, че редовното обезпаразитяване, ваксинация, профилактични прегледи са от особено важно значение за това домашният ни любимец да ни радва максимално дълго. Затова е съществено да сме наясно за всички интервенции, които той преживява. МЕРР дава възможност не само на Вас, но и на Вашия ветеринарен лекар да имате достъп до пълния здравен картон, да го обновявате и по този начин да осигурите най-пълноценните грижи за Вашия най-добър приятел. ',
    autoCreateTiile: 'Известия',
    autoCreateMessage: 'В забързаното ни ежедневие често пропускаме важни детайли.  Един от тях е часа за посещение при нашия ветеринарен лекар. За да сме сигурни, че това няма да се случи, МЕРР изпраща директни известия спрямо следния график на задаване: седмица по-рано, един ден по-рано и в самия ден. МЕРР мисли вместо Вас, работи за здравето на домашния любимец чрез директна синхронизация на информацията между собственика и ветеринаря. Всяко известяване е свързано с конкретна процедура, която може да зададете от изключително удобния календар и списък с услуги.',
    lostPetTtile: 'Изгубен любимец?',
    lostPetMessage: 'Най-големият страх на всеки стопанин е изчезването на неговия домашен любимец. МЕРР има отговор и на този проблем. При регистрация в системата вие получавате индивидуален идентификационен код, който е свързан и с чипа на Вашия четирикрак приятел. По този начин, ако той бъде заведен в която и да е било клиника, имаща профил в платформата, дежурният ветеринарен лекар ще може да Ви открие чрез нея и да Ви информира къде се намира той.',
    lostPetMessage2: 'Живейте без страх и притеснения!',
    featureServicesTitle: 'Очаквайте скоро!',
    featureServicesitle1: 'Външен вид',
    featureServicesBooking1: 'Много породи кучета и котки се нуждаят от професионални грижи за техния безупречен външен вид. Понякога това не е въпрос само на каприз и суета, а на здраве. Затова чрез МЕРР ще получавате информация къде бихте могли да намерите най-подходящите спрямо породата услуги от такъв тип.',
    featureServicesitle2: 'Правилно хранене',
    featureServicesBooking2: 'МЕРР не просто ще Ви помогне да бъдете винаги на линия за здравните нужди на Вашия домашен любимец, но и как да не се стига до принудителни посещения при ветеринарния лекар. Това се постига понякога чрез някои елементарни похвати. Всичко обаче започва от правилното хранене. От нас ще научавате за това кои храни са най-подходящи за всеки домашен любимец спрямо неговите специфики за възраст, тегло, порода и т.н.',
    priceTitle: 'Цена?',
    boricaSrc: '/img/borika-logo.svg',
    boricaUrl: 'https://www.borica.bg/',
    priceMessage: 'Всички услуги, които предлага МЕПП може да ползвате срещу 1,66 лева на месец. Заплащането става на годишна база при регистрация на домашния любимец, заплащате 19,99 лева за цяла календарна година! Плащането се извършва, чрез виртуален пос терминал, предоставен от ',
    freePriceMessage: 'Платформата е напълно безплатна за ползване, както от ветеринарни лекари, така и от собственици на домашни любимци...',
    services: 'Какви услуги предлагаме?',
    firstSlide: 'Регистрирай се',
    secondSlide: 'Добави домашния си любимец',
    thirdSlide: 'Започни да добавяш прегледи',
    fourSlide: 'Намери и дай достъп на ветеринаря си'
  },
  contact:{
    firm:'Фирма: Кей енд Ди Синерджи ЕООД',
    phone: 'Телефон: 0886 54 21 29',
    email: 'Имейл: myepet.passport@gmail.com',
    address: 'Адрес: България, гр. София, п.к. 1748, р-н Младост, ж.к. "Младост 1", бл. 40, вх. А, ет. 6, ап. 21',
    form: 'Или се свържете с нас през формата ни за контакти',
    title: 'Контакти',
    theme: 'Тема',
    sendEmail: 'Изпратихте Вашето съобщение успешно!'
  },
  button:{
    submit: 'Изпрати',
    update: 'Обнови',
    addImage: 'Добави снимка',
    removeImage: 'Премахни снимката',
    delete: 'Да',
    noDelete: 'Откажи',
    add: 'Добави',
    remove: 'Затвори',
    uploadVideo: 'Качи видео',
    petLose: 'Изгубено',
    search: 'Търсене',
    clear: 'Изчисти',
    addFavoriteDoctor: 'Добави в любими',
    removeFavoriteDoctor: 'Премахни',
    ok: 'Добре',
    yes: 'Да',
    create: 'Създай',
    terms: 'общите условия',
    gdprTitle: 'Политика за сигурност',
    gdpr: 'политиката за сигурност',
    and: ' и ',
    agreeTerms: 'Приемам ',
    resetPass: 'Забравена парола?',
    approvе: 'Одобри',
    favorite: 'любими',
    termsHeader: 'Общи услови и политика за сигурност',
    patientAgree: 'Собсвеникът на домашния любимец е запознат с ',
    patientAgreeWith: ' на системата и е съгласен да бъде регистриран.'
  },
  userNotification:{
    notificationTitle: 'Известия',
    noNotification: 'Нямате нови известия!',
    tommorow: 'Утре',
    afterWeek: ' трябва да се направи ',
    of: ' на ',
    ofWeek: 'Нa ',
    createReview: 'Желаете ли да създате преглед?',
    notificationDescription: 'От тук може да преглеждате, съобщенията свързани с Вашия домашен любимец',
    disableInfo: 'Паспортът на домашния Ви любимец може да бъде одобрен от Вашия ветеринарен лекар и секцията "Идентификация" няма да бъде достъпна за редакция.'
  },
  registration:{
    email: 'Имейл',
    firstName:'Име',
    lastName:'Фамилия',
    doctorFirstName: 'Име',
    doctorLastName: 'Фамилия',
    phoneNumber: 'Телефон',
    password: 'Парола',
    passwordLenth: ' (паролата трябва да е над 6 символа!)',
    passwordLenthError: 'паролата трябва да е над 6 символа!',
    field: 'Полето',
    validEmail: 'Моля попълнете валиден имейл',
    error: 'е грешно!',
    required: 'е задължително!',
    correct: 'Моля попълнете полетата коректно',
    updateCorrect: 'Обновихте Вашия профил успешно',
    requiredField: 'Полета със ',
    areRequired: ' са задължителни!',
    titleRegistration: 'Регистрирай се като: ',
    titleLogin: 'Влез като: ',
    user : 'Потребител',
    doctor: 'Ветеринарен лекар',
    imageUpload: 'Снимката е качена успешно!',
    removeUpload: 'Снимката е премахната успешно!',
    videoUpload: 'Видеото е качено успешно!',
    clinic: 'Клиника',
    website: 'Уеб сайт',
    requiredSymbol: '*',
    newPass: 'Вашата нова прарола (над 6 символа)!',
    language: 'Език',
    regNumber: 'Регистрационен №',
    haveRegistartion: 'Вече имате регистрация?',
    noRegistration: 'Нямате регистрация?',
    createPatientSuccess: 'Вие добавихте успешно ',
    createPatientSendEmail: 'Изпратен е имейл на собественика на домашния любимец!'
  },
  updateProfile: {
    oldPassword: 'Моля въведете Вашата стара парола',
    newPaswword: 'Моля въведете Вашата нова парола',
    country: 'Държава',
    city: 'Град',
    neighborhood: 'Квартал',
    validPhoneNumber: 'Моля, въведете валиден телефонен номер',
    sendEmail: 'Успешно обновихте Вашата парола. Моля, проверете Вашия имейл!',
    passwordChange: 'Смяна на парола'
  },
  modalText:{
    modalHeader: 'Внимание!',
    userWarning: 'Имате променена информация, която не е запазена.',
    modalQuestion: 'Желаете ли да я запазите?',
    modalSaveButton: 'Запази',
    deletePetReview: 'Сигурни ли сте, че искате да изтриете прегледа на ',
    deleteProfile: 'Сигурни ли сте, че искате да изтриета профила си?',
    yes: 'Да',
    no: 'Не'

  },
  users: {
    profile: 'Профил '
  },
  profile: {
    previewProfile: 'Лична информация',
    altImage: 'Профилна_снимка_',
    address: 'Адрес',
    edit: 'Редактирай',
    owner: 'Собственик ',
    space: ' ',
    userProfile: 'Добавяне собсвеник на домашен любимец',
    deleteProfile: 'Изтрий профила',
    ifDelete: 'Ако изтриете профила си ще загубите цялата информация свързана с Вашият домашен любимице, която е записана в системата!'
  },
  notifications:{
    notifHeader: 'Получаване на известия',
    byEmail: 'чрез имейл',
    byMApp: 'Чрез мобиплно приложение: ',
    on: 'Включено',
    off: 'Изключено'

  },
  pets: {
    pets: 'Домашни любимци',
    pet: 'Домашен любимец: ',
    addPet: 'добавете любимец',
    description: 'Описание',
    identification: 'Идентификация',
    pedigree: 'Родословие',
    name: 'Име на домашния любимец',
    species: 'Вид',
    breed: 'Порода',
    sex: 'Пол',
    birthDate: 'Дата на раждане',
    coat: 'Космена покривка',
    microchip: 'Номер на микрочипа',
    microchipping: 'Място на маркиране',
    dateMicrochipping: 'Дата на маркиране',
    tattooNumber: 'Татуировъчен номер',
    tattooDate: 'Дата на татуиране',
    kennel: 'Развъдник',
    mother: 'Майка',
    createPet: 'Регистрирахте Вашия любимец успешно',
    updateInfo: 'Обновихте информацията за Вашия любимец успешно',
    father: 'Баща',
    doctorApprove: 'Моля обърнете се към Вашия ветеринарен лекар да одобри информацията за този паспорт!',
    appRovedPassport: 'Одобрен от:',
    disabledInformation: 'Внимание след одобрение на паспорта, разделът "Идентификация" няма да бъде достъпен за редакция!',
    noPets: 'Все още нямате добавен домашен любимец',
    profile: 'Профил',
    yourPets: 'От тук може да видите Вашите домашни любимци',
    successPayment: 'Вашето плащане за една година за ',
    successPayment2:' е успешно! Следващо плащане след: 365 дни.'

  },
  presentation: {
    title: 'Как работи МЕПП?',
    owners: 'За собственици на домашни любимци',
    vets: 'За ветеринарни лекари',
    ownersLink: 'https://www.youtube.com/embed/OPEbg71lNS4',
    vetsLink: 'https://www.youtube.com/embed/4sUIpNZi6Ec'
  },
  petProfile: {
    previewPetProfile: 'Преглед профила на ',
    identNumber: 'Идентификационен номер',
    hide: 'Скрий профила',
    show: 'Покажи профила',
    delete: 'Изтрий',
    addReview: 'Добави преглед',
    pacients: 'Пациенти'
  },
  modals:{
    petReview: 'Добави преглед за ',
    modalPetBody: 'Сигурни ли сте, че искате да изтриете профила на ',
    modalPetReview: 'Сигурни ли сте, че искате да изтриете този преглед?'
  },
  petReview: {
    options: [
      {
        text: 'Ваксина против бяс',
        value: 'VAR',
        iconSrc: '/img/1-bqs.svg',
        iconSrcW: '/img/1-bqs-white.svg'
      },
      {
        text: 'Друга ваксина',
        value: 'OV',
        iconSrc: '/img/2-vaksina.svg',
        iconSrcW: '/img/2-vaksina-white.svg'
      },
      {
        text: 'Третиране срещу ектопаразити (бълхи,кърлежи)',
        value: 'TT',
        iconSrc: '/img/3-ekto.svg',
        iconSrcW: '/img/3-ekto-white.svg'
      },
      {
        text: 'Третиране срещу ехинококоза',
        value: 'ET',
        iconSrc: '/img/4-ehino.svg',
        iconSrcW: '/img/4-ehino-white.svg'
      },
      {
        text: 'Последно разгонване',
        value: 'PR',
        iconSrc: '/img/5-pr.svg',
        iconSrcW: '/img/5-pr-white.svg'
      },
      {
        text: 'Изследване',
        value: 'IZ',
        iconSrc: '/img/6-izsledwane.svg',
        iconSrcW: '/img/6-izsledwane-white.svg'
      },
      {
        text: 'Пристъп / Припадък',
        value: 'anAttack',
        iconSrc: '/img/7-pristap.svg',
        iconSrcW: '/img/7-pristap-white.svg'
      },
      {
        text: 'Операция',
        value: 'operation',
        iconSrc: '/img/8-operaciq.svg',
        iconSrcW: '/img/8-operaciq-white.svg'
      },
      {
        text: 'Легализация',
        value: 'legalisation',
        iconSrc: '/img/9-legalizaciq.svg',
        iconSrcW: '/img/9-legalizaciq-white.svg'
      },
      {
        text: 'Други',
        value: 'Others',
        iconSrc: '/img/10-drugi.svg',
        iconSrcW: '/img/10-drugi-white.svg'
      }
    ],
    filters: [
      {
        text: 'Ваксина против бяс',
        value: 'VAR'
      },
      {
        text: 'Друга ваксина',
        value: 'OV'
      },
      {
        text: 'Третиране срещу ектопаразити (бълхи,кърлежи)',
        value: 'TT'
      },
      {
        text: 'Третиране срещу ехинококоза',
        value: 'ET'
      },
      {
        text: 'Последно разгонване',
        value: 'PR'
      },
      {
        text: 'Изследване',
        value: 'IZ'
      },
      {
        text: 'Пристъп / Припадък',
        value: 'anAttack'
      },
      {
        text: 'Операция',
        value: 'operation'
      },
      {
        text: 'Легализация',
        value: 'legalisation'
      },
      {
        text: 'Други',
        value: 'Others'
      },
      {
        text: 'Всички',
        value: null
      }
    ],
    days: [
      {
        text: 'без известие',
        value: '0'
      },
      {
        text: '15 дни',
        value: '15'
      },
      {
        text: '1 месец',
        value: '30'
      },
      {
        text: '3 месеца',
        value: '90'
      },
      {
        text: '6 месеца',
        value: '182'
      },
      {
        text: '1 година',
        value: '365'
      }
    ],
    prText: 'Последно разгонване',
    izText: 'Изследване',
    imageFromIz: 'Снимка от изследването',
    uploadImageSuccess: 'Снимката е прикачена успешно!',
    uploadImageError: 'Снимката не е прикачена!',
    userAddReview: 'за да добавите преглед, моля използвайте бутона ',
    manufacturer: 'Производител',
    nameOfVaccine: 'Наименование на Ваксината',
    nameOfProduct: 'Наименование на медикамента',
    batchNumber: 'Партиден номер',
    vaccinationDate: 'Дата на ваксинация:',
    date: 'Дата',
    validUntil: 'Известие след',
    remaindingOn: 'Известие на',
    comment: 'Коментар',
    legalisationBody: 'Обект на легализацията',
    filterBy: 'Покажи: ',
    uploaded: 'Видеото е прикачено успешно!',
    owner: 'Собственик ',
    addByDoctor: 'д-р ',
    titleReview: 'Преглед',
    titleAddDate: 'Дата:',
    tiitleNotificationDate: 'Известие на',
    tiitleNotificationDateMobile: 'Известие ',
    adddByTitle: 'Добавил прегледа',
    adddByTitleMobile: 'Добавил',
    reviews: 'Прегледи',
    noReviews: 'Все още няма добавени прегледи за '

  },
  doctor:{
    doctors: 'Ветеринарни лекари',
    filter: 'Филтър',
    regVtes: 'Търсене на регистрирани ветеринарни доктори',
    or: 'или',
    searchPetHeader: 'Търсене на домашен любимец по: ',
    noResult: 'Няма намерени ветеринарни лекари!',
    noFindResult: 'Няма намерени резултати!',
    ownerSearching: 'За да намерите собственика на домашния любимец, моля въведете номер на микрочипа!',
    addPetReview: 'За да добавите преглед, намерете домашния любимец по идентификационен номер или номера на микрочипа',
    noVet: 'Все още нямате любими ветеринарни лекари. За да може ветеринарният лекар да преглежда, трие и добавя прегледи трябва да сте го добавили в "Любими ветеринарни лекари"!',
    searchDoctorHeader: 'Търсене на ветеринарен лекар',
    favoriteDoctors: 'Любими ветеринарни лекари: ',
    favoriteDoctorsHeader: 'Любими ветеринарни лекари',
    noFavoriteDoctors: 'Няма добавени любими ветеринарни лекари!',
    searchDoctorHeaderCriteria: 'Търсене на ветеринарен лекар по:',
    successAdd: 'Успешно добавихте ',
    inFav: ' в любими ветеринарни лекари!',
    addedVet: ' вече е добавен в списъка Ви с любими ветеринарни лекари!',
    deleteVet: 'Сигурни ли сте, че искате да премахнете д-р ',
    fromFav: ' от Вашия списък с любими ветеринарни лекари?',
    searchVet: 'От тук може да търсите ветеринарни лекари',
    addPatient: ' Пациенти',
    paymentDoctor: 'За всяка годишна такса заплатена от всеки един Ваш пациент, Вие получавате 30% за първата такса и за всяка следваща по 10%'
  },
  errors: {
    imageError: 'Невалиден формат на снимката!',
    videoError: 'Невалиден формат за видео!',
    doctorSearchError: 'Моля въведете критерии за търсене!'
  },
  serverError: {
    serverError: 'Възникна грешка',
    invalidEmail: 'Невалиден имейл адрес!',
    busyEmail: 'Въведеният имейл вече е регистриран!',
    emptyEmail: 'Моля въведете Вашия имейл!',
    validEmail: 'Моля въведете валиден имейл адрес!',
    wrongEmail: 'Въведеният имейл адрес е грешен!',
    invalidFirstName: 'Невалиден формат за Вашето име, моля въведете името си!',
    firstNameLengt: 'Името Ви трябва да съдържа минимум 3 букви!',
    firstNameSymbol: 'Името Ви може да съдържа букви и празни разтояния!',
    invalidLastName: 'Невалиден формат за Вашата фамилия, моля въведете фамилия си!',
    LastNameLengt: 'Фамилията Ви трябва да съдържа минимум 3 букви!',
    LastNameSymbol: 'Фамилията Ви може да съдържа букви и празни разтояния!',
    emptyPassword: 'Моля въведете Вашата парола!',
    passwordLengt: 'Паролата Ви трябва да съдържа най-малко 6 символа!',
    wrongPassword: 'Въведената парола е грешна!',
    oldPassword: 'Старата Ви парола трябва да съдържа най-малко 6 символа!',
    newPassword: 'Новата Ви парола трябва да съдържа най-малко 6 символа!',
    petName: 'Моля въведете името на Вашия домашен любимец!',
    petNameLengt: 'Името на Вашия любимец трябва да съдържа минимум 3 букви!',
    petNameSymbol: 'Името на Вашия любимец може да съдържа букви и празни разтояния!',
    emptyPetSpecies: 'Въведете вид на Вашия любимец!',
    petSpeciesSymbol: 'Видът на Вашия любимец може да съдържа букви и празни разтояния!',
    emptyPetBreed: 'Въведете порода на Вашия любимец!',
    petBreedSymbol: 'Породата на Вашия любимец може да съдържа букви и празни разтояния!',
    emptyPetSex: 'Въведете пола на Вашия любимец!',
    petSexSymbol: 'Полът на Вашия любимец може да съдържа букви и празни разтояния!',
    emptyPetBirthDay: 'Въведете датата на раждане на Вашия любимец!',
    petBirthDaySymbol: 'Датата на раждане на Вашия любимец може да съдържа цифри и символи!',
    emptyPetCoat: 'Въведете космена покривка на Вашия любимец!',
    petCoatSymbol: 'Космената покривка на Вашия любимец може да съдържа букви и празни разтояния!',
    regNumberError: 'Полето регистрационен № е задължителен!',
    clicniError: 'Полето клиника е задължително!',
    notFound: 'Страницата не е намерена',
    petIsRegistrated: 'Този домашен любимец вече е регистриран, ако желаете да добавите домашен любимец, моля да се върнете на началната страница.',
    notPayed: 'За да може да преглеждате, триете и добавяте прегледи на домашния любимец и за да бъде видим профилът му за ветеринарни лекари, трябва да е заплатена годишната такса за него!',
    howToPay: 'За да платите, моля отидете на ',
    homePageLink: 'началната страница.',
    notPayedFee: 'Домашният любимец е регистриран в системата, но годишната такаса не е платена и информацията не може да бъде показана!',
    doctorAutorization: 'За да може да преглеждате, триете и добавяте прегледи, моля обърнете се към собственика на домашния любимец, да Ви добави в "Любими ветеринарни лекари"!'
  },
  payment:{
    paymentTitle: 'Плащане',
    paymentText: 'Оставащо време до плащане за ',
    paymentDays: 'Дни',
    markForPay: 'Маркирай за плащане: ',
    paypal: 'Плащане чрез Paypal',
    totalPrice: 'дължима сума: ',
    totalCurrency: 'BGN',
    description: 'Annual fee to the pet system MEPP',
    pay: 'Плащане',
    price: '19.99',
    successPayment: 'Вашето плащане е получено успешно. Ще получите имейл с данни за извършеното плащане.',
    errorPayment: 'Възникна грешка при Вашето плащане, моля опитайте отново!',
    redirectBorika: 'Ще бъдете пренасочени към платформата за виртуално разплащане на '
  },
  regis: {
    title: 'Регистрации в МЕПП:'
  },
  flags: {
    flag:[{
      value: 'bg_BG',
      text: 'BG',
      alt: 'България',
      src: '../assets/flags/bulgaria-flag-icon-64.png'
    },
    {
      value: 'en_EN',
      text: 'EN',
      alt: 'English',
      src: '../assets/flags/european-union-flag-icon-64.png'
    },
    {
      value: 'us_US',
      text: 'US',
      alt: 'English',
      src: '../assets/flags/bulgaria-flag-icon-64.png'
    }]
  },
  aboutUs: {
    about: 'За нас',
    firstParagraf: 'Домашният любимец е нашият най-добър приятел и част от семейството ни!  ',
    firstParagraf1: 'Тази максима знаят всички стопани, когато се приберат вкъщи и видят обожанието в очите на своите четирикраки приятели. За да бъдем възможно най-дълго заедно, ние трябва отговорно да се грижим за тях.',
    firstParagraf2: 'Затова създадохме МЕРР – за всички Вас, които споделяте живота си с пухкав другар. МЕРР е онова приложение, което обединява функционалностите, които всички собственици на домашни любимци искат: ',
    firstQuestion: '-       Бърз достъп до цялата здравна история на домашния любимец;',
    secondQuestion:'-      Бързо и лесно да филтрирате само прегледите, които Ви итересуват;',
    thirdQuestion: '-       Постоянна връзка между стопанин и ветеринарен лекар;',
    fourtQuestion: '-       Регулярни известия за предстоящи прегледи, ваксинации и обезпаразитявания;',
    fiveQuestion: '-       Да пазите всички снимки от изследванията на едно място;',
    secondParagraf3: 'При разработката на системата съчетахме своя собствен опит, както и знанията и експертизата на ветеринарни лекари, развъдчици и други специалисти и любители на животните.',
    secondParagraf: 'Информацията в МЕПП е достъпна с един клик - по всяко време и във всяка точка на света, така че здравният картон на домашния любимец да е постоянно в ръката Ви, чрез мобилния телефон. Не е нужно да се притеснявате дали помните кога е била последната ваксина или последното хапче за вътрешно обезпаразитяване. Вече можете след всеки преглед да попълвате тази информация онлайн, а чрез един клик да дадете достъп на Вашия ветеринарен лекар да добавя още нужни детайли. Защото доверието в такива отношения е най-важно и ние, създателите на МЕРР, знаем това.',
    secondParagraf2: 'Чрез приложението бихте могли дори да откриете местонахождението на Вашия загубен домашен любимец, тъй като чрез неговата регистрация и индивидуален код и чипиране, всяка вписана клиника ще може да види реалния собственик. ',
    thirtParagraf: 'За нас отговорността към здравето, щастието и усмивката на животните е от първостепенна важност. Затова предлагаме услуга, която завинаги да промени и улесни грижата за тях.',
    thirtParagraf1: 'Бъдете отговорни към тези, които обичате.',
    thirtParagraf2: 'МЕРР вече работи за Вас!'
  },
  faq:{
  title: 'FAQs',
  pageTitle: 'Често задавани въпроси',
  faq:
  [
    {
      q:'Какво да правя ако изгубя моят домашен любимец?',
      a: 'Сигнализирайте в полицията, като предоставите данните на Вашия любимец от Общинския регистър на домашните любимци.'
    },
    {
      q:'Къде да съобщя за безстопанствено куче? ',
      a: 'Институцията за закрила на животните в България е БАБХ.'
    },
    {
      q:'Коя институция да сезирам за малтретиран домашен любимец? ',
      a: 'В зависимост от държавата и града, в който се намирате отговорът на този въпрос варира. За България, това са областните дирекции на БАБХ. (BFSA)'
    },
    {
      q:'След коя ваксина мога да извеждам моят любимец навън? ',
      a: 'Препоръчително е да се направят всички ваксини преди да извеждате Вашия любимец навън. '
    },
    {
      q:'Упояват ли животните за прическа при фризьор? ',
      a: 'В общия случай, животните се седират, но са в съзнание. Ако са спокойни, може и да се пропусне.'
    },
    {
      q:'Колко често се почиства зъбен камък на куче? ',
      a: 'Тук отговорът е индивидуален, но в общия случай на всеки 6 месеца.'
    },
    {
      q:'Полезно ли е котките да се кастрират? ',
      a: 'Приема се, че кастрацията удължава живота на Вашия любимец.'
    },
    {
      q:'Приема се, че кастрацията удължава живота на Вашия любимец.',
      a: 'Обикновено в рамките на първата година от живота им.'
    },
    {
      q:'Колко често се обезпаразитяват котките? ',
      a: 'Зависи според това дали домашният любимец живее в затворено или отворено пространство. Ако има свободен достъп до външна среда, препоръчително е на всеки 3-4 седмици да се обезпаразитява. '
    },
    {
      q:'Какво да правя ако изгубя паспортът на моя домашен любимец? ',
      a: 'Отидете при ветеринарният лекар, който първоначално е издал паспорт на Вашия любимец. Той следва да пази информацията му и да Ви издаде дубликат.'
    }
  ]},
  footer: {
    allRights: 'Всички права запазени'
  },
  menu:{
    followUs: 'Следвайте ни: '
  },
  dbTransalte: {
    langCode: 'bg_BG',
    subject: 'Забравена парола',
    hello: 'Здравейте',
    message: 'ако желаета Вашата парола да бъде обновена, моля натиснете бутона:',
    regards: 'Поздрави',
    team : 'Екипът на МЕПП',
    confirm: 'Одобрявам'
  },
  emailTransalte: {
    langCode: 'bg_BG',
    subject: 'Съобщение свързано с ',
    hello: 'Здравейте',
    message:'Вие имате ново съобщение свързано с',
    regards: 'Поздрави',
    team : 'Екипът на МЕПП',
    noMessage: 'Ако не желаете повече да получавате известия за Вашия домашен любимец, може да изключите имейл известията от Вашият профил',
    goToWebsite:'Моля посетете нашия уеб сайт, за да видите съобщението:'
  },
  emailPaymentTransalte: {
    langCode: 'bg_BG',
    subject: 'Плащанщане за ',
    hello: 'Здравейте',
    message:'Вие имате ново съобщение свързано с плащането за годишен достъп до предлаганите от нас услуги.',
    regards: 'Поздрави',
    team : 'Екипът на МЕПП',
    noMessage: 'Ако не желаете повече да получавате известия за Вашия домашен любимец, може да изключите имейл известията от Вашият профил',
    goToWebsite:'Моля посетете нашия уеб сайт, за да платите.'
  },
  gdpr:{
    header: 'ПОЛИТИКА ЗА ПОВЕРИТЕЛНОСТ НА ЛИЧНИ ДАННИ',
    secondHeader: 'НА „Кей енд Ди Синерджи“ ЕООД',
    thirdHeader: 'Данни за Администратора:',
    p1: '„Кей енд Ди Синерджи“ ЕООД, ЕИК 206122486,  e администратор на лични данни с основен предмет на дейност: Търговско представителство и посредничество, търговия на едро и дребно, разработване на софтуер, изработване на онлайн приложения и платформи, консултантски услуги, управление и мениджърски услуги, маркетингови и рекламни услуги, инвестиции, търговия, посреднически услуги, посреднически услуги при сделки с активи, както и всички други дейности, които не са забранени от закона.',
    p2: '„Кей енд Ди Синерджи“ ЕООД притежава и оперира електронна платформа - Моят електронен паспорт за домашни любимци (МЕПП), с електронната страница (сайт): ',
    site:'https://my-epet.com/',
    p3: 'Моят електронен паспорт за домашни любимци (МЕПП) е онлайн платформа за връзка между ветеринарни лекари и стопани на домашни любимци. Платформата работи в подпомагане стопаните на домашни любимци да имат достъп до нужната за тях информация свързана с здравословното състояние на техните домашни любимци. Моят електронен паспорт за домашни любимци осигурява активен обмен на информация между ветеринарни лекари и пациентите им, и чрез интензивни вътрешни комуникации и поддържане на уеб страница.',
    dh: 'Данни за контакт с „Кей енд Ди Синерджи“ ЕООД, ЕИК 206122486:',
    dc: 'Държава: България',
    dc1: 'Седалище и адрес на управление: гр. София, п.к. 1748, р-н Младост, ж.к. "Младост 1", бл. 40, вх. А, ет. 6, ап. 21',
    dp: 'Телефон: 0886542129',
    de: 'Ел. поща: myepet.passport@gmail.com',
    p4: 'Извършвайки своята дейност, „Кей енд Ди Синерджи“ ЕООД извършва законни и регулирани действия по събиране, обработка и съхранение на лични данни в съответствие с Регламент (ЕС) № 2016/679 (наричани „Регламента“) и националното законодателство за защита на личните данни.',
    h1: 'Личните данни, които събираме и обработваме от вас, в качеството на потребител на сайта ',
    h2: ', са:',
    p5: 'Име, фамилия, мобилен телефон, електронна поща (месторабота, при регистрация на ветеринарен лекар).',
    h3: 'Декларираме, че личните данни, които събираме, ще бъдат използвани единствено за следните цели:',
    t1: '•	За целите на използване и функциониране на сайта ',
    t2: ' и предлаганите от него услуги;',
    t3: '•	За целите на упражняване на легитимния интерес на „Кей енд Ди Синерджи“ ЕООД.',
    h4: 'Основанието, което ни дава право да обработваме вашите данни е:',
    d1: '•	Съгласие на потребителите;',
    d2: '•	Изпълнение на задълженията на Дружеството по Регламент (ЕС) 2016/679 и националното законодателство;',
    d3: '•	Легитимен интерес.',
    p6: 'Обработването е необходимо с оглед използването на сайта и неговите функционалности, както и дейности, съставляващи легитимен интерес за  „Кей енд Ди Синерджи“ ЕООД.',
    h5: 'Цели и принципи',
    p7: '„Кей енд Ди Синерджи“ ЕООД спазва всички принципи, включени в Глава втора от GDPR при обработка на личните ви данни, включително:',
    t4: '- легитимност, добросъвестност и прозрачност;',
    t5: '- ограничаване на целите за обработка;',
    t6: '- подчиняване на целите на обработката на равни начала с минимизиране на събрани данни;',
    h6: '„Кей енд Ди Синерджи“ ЕООД не събира и не обработва чувствителни лични данни, включително лични данни, които:',
    t7: '- разкриват расов или етнически произход;',
    t8: '- разкриват политически мнения, религиозни или философски убеждения или     членство в профсъюзи;',
    t9: '- генетични и биометрични данни, данни относно здравето или сексуалния живот и сексуалната ориентация.',
    p8: 'Трябва да сте навършили 16 години, за да можете да се създадете Ваша регистрация в сайта ',
    p9: '. „Кей енд Ди Синерджи“ ЕООД не изисква и съзнателно не събира лични данни от или за деца на възраст под 16 години, без съгласието на родител или настойник. Ако все пак Дружеството научи, че лични данни, отнасящи се за деца на възраст под 16 години, са му предоставени без съгласието на родител или настойник, тази информация ще бъде изтрита възможно най-бързо или, в случай че изтриването не е възможно, личните данни няма да се използват за каквато и да било цел и няма да бъдат разкривани на трети лица.',
    h7: '„Кей енд Ди Синерджи“ ЕООД обработва данни:',
    t10: '- предоставени от субекта на данни (потребителя на сайта) при регистрация (и редакция на профил) в сайта ',
    t11: '- предоставени (въведени в сайта) от регистриран в сайта ветеринарен лекар.',
    t12: '- предоставени чрез попълване на Декларация за съгласие.',
    h8: 'Следните организации/лица ще получат личните ви данни',
    p10: 'В случай на инцидентна необходимост от предаване на Вашите лични данни на други трети лица, непосочени тук, това ще става след Вашето изрично съгласие и при спазване на действащото законодателство за защита на личните данни.',
    p11: 'За изпълнение на задълженията на администратора в областта на счетоводството и данъчното законодателство, в съответствие със законово задължение, „Кей енд Ди Синерджи“ ЕООД може да предостави вашите данни на съответните държавни органи и трети страни - данъчни органи и институции за социално осигуряване, съдилища, съдебни изпълнители, обществени изпълнители и органи и други.',
    h9: 'Предаване на личните данни на трети страни',
    p12: '„Кей енд Ди Синерджи“ ЕООД  се ангажира да не предава лични Ви данни на трети лица извън ЕС или на международна организация, без предварително да получи Вашето съгласие.',
    p13: '„Кей енд Ди Синерджи“ ЕООД  счита за необходимо да Ви уведоми, че за целите на обработването на личните Ви данни използваме информационни системи за организиране на база данни, като поддръжката и IT-обслужването на приложения към тези системи се осъществява от трети (външни) лица. ',
    h10: 'Използване на „Cookies”',
    p14: '„Кей енд Ди Синерджи“ ЕООД  счита за необходимо да Ви уведоми, че за целите на използването на услуги посредством електронната страница (',
    p15: '), „Кей енд Ди Синерджи“ ЕООД  използва „Cookies” („Бисквитки”).',
    p16: 'Бисквитките помагат на „Кей енд Ди Синерджи“ ЕООД да разбере предпочитанията и интересите на потребителите на сайта, базирани на предишна и/или настояща тяхна активност в сайта. Информацията, получена вследствие на използването на бисквитки, подпомага „Кей енд Ди Синерджи“ ЕООД да подобри обслужването и функционалностите и услугите на сайта, които „Кей енд Ди Синерджи“ ЕООД предоставя на потребителите.',
    h11: 'Период на съхраняване на данните',
    p17: '„Кей енд Ди Синерджи“ ЕООД ще съхранява Вашите лични данни не повече от  сроковете, установени в законовите и подзаконовите нормативни актове на действащото трудово, данъчно и осигурително законодателство, за съблюдаването на които Дружеството е съставило нарочен График за съхранение и унищожаване на данни. Данните ще бъдат съхранявани в съответствие с Процедура за съхраняване и унищожаване на данните.',
    h12: 'Вашите права като субект на личните данни са следните:',
    p18: 'Във всеки момент, докато съхраняваме или обработваме личните ви данни, Вие (според терминологията на закона - субект на данните) имате следните права:',
    h13: 'Оттегляне на съгласието',
    p19: 'Ако не желаете всички ваши лични данни или част от тях да продължават да бъдат обработвани от „Кей енд Ди Синерджи“ ЕООД за конкретни или всички цели на обработка, можете по всяко време да изтеглите вашата съгласие за обработка чрез попълване на формуляра за кандидатстване или чрез заявка в свободен текст. „Кей енд Ди Синерджи“ ЕООД може да поиска да удостоверите самоличността си с лицето, което е обект на тези данни. Чрез оттегляне на съгласието за обработка на лични данни, които са необходими за създаване и поддържайте регистрацията си за използването на приложения и софтуерни системи, вашият акаунт ще стават неактивни. Всички данни се обработват до оттеглянето на съгласието законно.',
    h14: 'Право на достъп',
    p20: 'Имате право да изискате и получите потвърждение от „Кей енд Ди Синерджи“ ЕООД във всеки случай личните данни, свързани с вас, се обработват. Имате право на достъп до личните си данни, както и информацията относно събирането, обработката и съхранението на горепосочените данни. „Кей енд Ди Синерджи“ ЕООД Ви предоставя копие на обработените лични данни свързани с вас, при поискване, в писмена или електронна форма, ако е възможно. Предоставяне на достъп до данните е безплатно, но „Кей енд Ди Синерджи“ ЕООД си запазва правото да наложи административна такса в случай на прекомерни претенции и злоупотреба с това право.',
    h15: 'Право на коригиране или допълване',
    p21: 'Можете да допълните и/или да коригирате непълните/неточните си лични данни от своя акаунт (профил) в сайта ',
    p22: ' или да поискате „Кей енд Ди Синерджи“ ЕООД да коригира вашите неправилни или непълни лични данни.',
    h16: 'Право да бъдете забравен',
    p23: 'Имате право да поискате от „Кей енд Ди Синерджи“ ЕООД личните Ви данни да бъдат изтрити без ненужно забавяне при наличието на някое от следните основания: ',
    t13: '•	личните данни повече не са необходими за целите, за които са били събрани; ',
    t14: '•	когато сте оттеглил своето съгласие; ',
    t15: '•	когато сте възразил срещу обработването, ',
    t16: '•	когато обработването е незаконосъобразно; ',
    t17: '•	когато личните данни трябва да бъдат изтрити с цел спазването на правно задължение по правото на EС или правото на държава членка, което се прилага спрямо нас като администратор на лични данни; ',
    p24: '„Кей енд Ди Синерджи“ ЕООД  може да откаже да заличи личните Ви данни по следните причини:',
    t18: '•	за спазване на законово задължение от наша страна или за изпълнението на задача от обществен интерес; по причини от обществен интерес в областта на общественото здраве;',
    t19: '•	за защита във връзка с правни искове и производства.',
    t20: '•	за целите на архивирането в обществен интерес, за научни или исторически изследвания или за статистически цели, доколкото съществува вероятност заличаването да направи невъзможно или сериозно да затрудни постигането на целите на това обработване или за установяването, упражняването или защитата на правни претенции.',
    h17: 'Право да поискате ограничение на обработването',
    p25: 'Имате право да поискате от „Кей енд Ди Синерджи“ ЕООД да ограничи обработването на личните Ви данни, като в този случай данните ще бъдат само съхранявани, но не и обработвани по друг начин. Отказът ни за ограничаване ще е изрично само в писмен вид, като сме длъжни да го мотивираме със законосъобразната причина;',
    h18: 'Право на преносимост на данните',
    p26: 'Имате право да поискате от „Кей енд Ди Синерджи“ ЕООД директно да предават вашите лични данни на друг администратор, посочен от вас, където това е технически възможно.',
    h19: 'Право на получаване на информация',
    p27: 'Имате право да изискате „Кей енд Ди Синерджи“ ЕООД да Ви информира за всички страни, на които са разкрити Ваши лични данни (ако има такива), както и за това дали е извършена корекция, заличаване или ограничаване на обработката, ако това е било поискано от Вас. „Кей енд Ди Синерджи“ ЕООД може да откаже да предостави тази информация, ако това е така невъзможно или би изисквало непропорционални усилия;',
    h20: 'Вашите права в случай на нарушаване на сигурността ',
    p28: 'Когато „Кей енд Ди Синерджи“ ЕООД открие нарушение на личните данни, което може да доведе до висок риск за вашите права и свободи, ще Ви бъдеш съобщено за нарушението на сигурността на личните данни без неоправдано забавяне, както и за предприетите или предложените мерки.',
    p29: '„Кей енд Ди Синерджи“ ЕООД не е длъжно да ви информира, ако:',
    t21: '- Дружеството е приложило подходящи технически и организационни мерки за защита и тези мерки са били приложени;',
    t22: '- Дружеството е предприело последващи мерки, които гарантират, че високият риск за вашите права вече няма да се осъществи;',
    t23: '- уведомлението би изисквало непропорционални усилия.',
    h21: 'Имате право на жалба до надзорния орган',
    p30: 'Имате право да подадете жалба директно до надзорния орган в Република България - Комисия за защита на личните данни, адрес:',
    p31: 'Адрес: гр. София 1592, бул. „Проф. Цветан Лазаров” № 2;',
    p36: 'тел. 02 915 3 518',
    p32: 'Електронна поща: kzld@government.bg , kzld@cpdp.bg',
    p33: 'Електронна страница: (www.cpdp.bg)',
    p34: 'или до надзорен орган в държавата-членка на обичайното Ви местопребиваване, място на работа или място на предполагаемото нарушение, в случай че считате, че обработването на лични данни, отнасящи се до Вас, нарушава разпоредбите на Регламент (ЕС) 2016/679 и/или Закона за защита на личните данни.',
    p35: 'В случай, че желаете да подадете жалба относно обработката на личните Ви данни чрез „Кей енд Ди Синерджи“ ЕООД, можете да го направите на посочените данни за контакт на „Кей енд Ди Синерджи“ ЕООД.',
    h22: 'Цени и Анулационна политика',
    p36: 'В Платформата има посочени цени в лева.	Сумата, която Потребителят заплаща за Услугата е крайна и включва ДДС.	Кей енд Ди Синерджи практикува стриктна анулационна политика и Потербителят следва да има предвид, че: ',
    h23: 'Промяна на условията',
    p40: 'Кей енд Ди Синерджи си запазва правото едностранно да променя Общите условия, както и структурата на своята Интернет страница, за което се задължава да уведомява Потребителите, чрез публикуване на съобщение на началната страница на Кей енд Ди Синерджи, в 7 (седем) дневен срок, считано от насътпване, и/или от публикуване на промяната на Общите условията.'
  },
  generalTerms: {
    button: 'Общи условия',
    title: 'ОБЩИ УСЛОВИЯ ЗА ИЗПОЛЗВАНЕ НА ОНЛАЙ ПЛАТФОРМА ',
    link: 'https://my-epet.com/',
    h1: 'I.	ПРЕДМЕТ И ОБЩИ ПОЛОЖЕНИЯ',
    p1: '1.	Настоящите Общи условия (наричани по-долу за краткост „Общи условия“)  за ползване на онлайн платформа за връзка между ветеринарни лекари и стопани на домашни любимци ',
    p2: ' (наричана по-долу за краткост Платформата) и за използване на предоставяните чрез нея услуги, уреждат отношенията между “Кей енд Ди Синерджи“ ЕООД, с ЕИК 206122486 (наричано за краткост „Кей енд Ди Синерджи“), в качестовото си на търговец и собственик на Платформата, от една страна и всяко лице, включително и ветеринарен лекар, и/или стопанин на домашен любимец (наричано по-долу за краткост „Потребител“) от друга страна, което ползва, по какъвто и да е начин Платформата.',
    p3: '2.	По смисъла на Общите условия, Платформата е следната интнернет страница, находяща се на следния интернет домейн адрес ',
    p4: ', както и всяка друга интернет страница, регистрирана от Кей енд Ди Синерджи.',
    p5: '3.	Платформата, работи в подпомагане на Потребителите, в качеството си на стопаните на домашни любимци да имат достъп до нужната за тях информация свързана със здравословното състояние на техните домашни любимци и осигурява активен обмен на информация между ветеринарни лекари и пациентите им, и чрез интензивни вътрешни комуникации и поддържане на уеб страница.и други услуги (наричани по-долу за краткост Услуги), които изготвя, предлага и предоставя Кей енд Ди Синерджи.',
    p6: '4.	С ползването на Платформата Потребителят се съгласява с Общите условия.',
    p7: '5.	Потребителят се задължава да ползва Платформата и Услугите в съответствие с изискванията на настоящите Условия, както и с Политиката за поверителност, публикувана на Платформата.',
    p8: '6.	В случай, че Потребителят не е съгласен с което и да е от Общите условия, Потребителят не е възможно да ползва Платформата, и/или Услугите и е възможно да прекратите участието си като страна по Общите условия, като преустанови използването и достъпването на Платформата.',
    p9: '7.	Платформата препоръчва използването на Платформата и Услугите от пълнолетни лица, или от непълнолетни, чрез техните законни представители.',
    h2: 'II. ИЗПОЛЗВАНЕ НА ПЛАТФОРМАТА И ПРЕДОСТАВЯНИТЕ УСЛУГИ',
    p10: '8.	Всички въпроси на Потребителя, или на трети лица, свързани с ползването на на Платформата, могат да бъдат задавани от Потребителя, или от третото лице, чрез изпращане на съобщение във формата за въпроси, на електронната поща myepet.passport@gmail.com , или на посочен в секцията „Помощ“ или друга секция на Платформата, създадена за тази цел.',
    p11: '9.	Всеки Потребител, който ползва Платформата, има право да изрази мнение по отношение на Платформата, чрез изпращане на лично съобщение до Кей енд Ди Синерджи на електронната поща myepet.passport@gmail.com .',
    p12: '10.	Потребителят, или всяко друго трето лице, се задължава да уведомява за грешки, технически проблеми и други проблеми, свързани с ползването на Платформата, чрез изпращане на лично съобщение до Кей енд Ди Синерджи на електронната поща myepet.passport@gmail.com .',
    p13: '11.	Платформата е обект на творческа дейност и е под закрилата на Закон за авторското право и сродните му права, поради което е забранено всяко копиране, и/или възпроизвеждане на която и да е част от съдържанието, механичните, електрическите и логични сигнали, и/или протоколи от Платформата, както и което и да е друго нарушаване на авторски и сродни права, права върху търговски марки или други права на интелектуална собственост, съгласно Закон за авторското право и сродните му права.',
    p14: '12.	Всеки Потребител, който ползва Платформата, има право да изрази мнение по отношение на Платформата, чрез изпращане на лично съобщение до Кей енд Ди Синерджи ',
    p15: '13.	При ползване на Услуги, при които се осъществява публикуване на съобщения или друг вид съдържание на Платформата е забранено нарушаването на авторски и сродни права, права върху търговски марки или други права на интелектуална собственост.',
    p16: '14.	Всички въпроси на Потребителя, или на трети лица, свързани с ползването на предлаганите Услуги на Платформата, могат да бъдат задавани от Потребителя, или от третото лице, чрез изпращане на лично съобщение до Кей енд Ди Синерджи.',
    p17: '15.	Услугите са обект на творческа дейност и са под закрилата на Закон за авторското право и сродните му права, поради което е забранено всяко копиране, и/или възпроизвеждане на която и да е част от съдържанието им, както и което и да е друго нарушаване на авторски и сродни права, права върху търговски марки или други права на интелектуална собственост, съгласно Закон за авторското право и сродните му права.',
    p18: '16.	Услугите е възможно да са обект на търговска тайна и са под закрилата на Търговски закон, поради което Кей енд Ди Синерджи и Потребителят са длъжни да пазят търговската тайна на Кей енд Ди Синерджи и на лицата, възложили на Кей енд Ди Синерджи извършването на определена работа, както и техния търговски престиж.',
    p19: '17.	Възможно е Платформата да съдържа грешки, пропуски, закъснения в обновяването на данните и информацията, както и достъпът до него да прекъсва, затова Кей енд Ди Синерджи си запазва правото да редактира Платформата и да прекратява достъпа до нея по всяко време.',
    h3: 'III. ПОТРЕБИТЕЛ',
    p20: '18.	Потребители по смисъла на настоящите Общи условия могат да бъдат всички дееспособни и пълнолетни физически лица',
    p21: '19.	Всеки Потребител, или трето лице, преди, и/или по време, и/или след всяко ползване на Платформата, и/или на Услугите, се задължава:',
    p22: '19.1.	С което и да е свое действие, или бездействие, да не накърнява, и/или нарушава, и/или предпоставя, и/или застрашава да бъдат нарушени доброто име на Кей енд Ди Синерджи, и/или на действащото законодателства в Република България, международните актове, както и да не застрашава работоспособността на програмните и технически средства, чрез които се предоставят Услугите, включително и на други предприятия, предоставящи електронни съобщителни услуги',
    p23: '19.2.	Да не разпространява чрез Интернет, и/или чрез SMS, и/или чрез Платформата, и/или чрез Услугите, и/или чрез какъвто и да е друг начин, нецензурни, обидни или заплашителни текстове и/или изображения, включително такива на расова, религиозна, верска, или политическа основа, както и за подбудителсвто, подготовка или помагачество за което и да е от престъпленията в Наказателния кодекс, както и за потъпкване, и/или дискриминиране на което и да е от правата на човека съгласно Харта на правата на Европейския съюз, както и за разпространение на каквито и да са персонални, публични, рекламни, или търговски съобщения.',
    p24: '20.	Всеки Потребител, или трето лице, при ползване на Платформата, и/или на Услугите, в случай, че участва във форуми, блогове, или каквато и да е друга комуникация в Платформата, се задължава да спазва следните изисквания:',
    p25: '20.1.	Да поставя съобщения (posts), изписани само на български език, като има право да използва писмените знаци на латинския език единствено с цел изясняване на изказа, както и при технологични термини, търговски марки и брандове, идиоми и жаргон. Текстове на английски или друг език ще бъдат редактирани от съответните администратори на съответната Интернет страница.',
    p26: '20.2.	Да не поставя/ използва на Платформата нецензурни, обидни или заплашителни текстове и/или изображения, включително такива на расова, религиозна, верска, или политическа основа, както и за подбудителсвто, подготовка или помагачество за което и да е от престъпленията в Наказателния кодекс, както и за потъпкване, и/или дискриминиране на което и да е от правата на човека съгласно Харта на правата на Европейския съюз, както и за разпространение на каквито и да са персонални, публични, рекламни, или търговски съобщения.',
    p27: '20.3.	Да не поставя на Платформата търговски, рекламни текстове и/или изображения, както и off-topic съобщения.',
    p28: '20.4.	Да не използва устройство или софтуер в опит да се намесва в правилното функциониране на Платформата.',
    p29: '21.	Всякакви сведения, публикации, и/или други обективирани по какъвто и да е начин волеизявления на Потребители, посетители, клиенти или други лица извън Кей енд Ди Синерджи, принадлежат на автора си и Кей енд Ди Синерджи не носи отговорност за тяхната истинност и достоверност.',
    p30: '22.	Потребителят единствен носи отговорност за всички щети, настъпили в резултат на нарушаване на права на собственост и други вреди, настъпили в резултат на използването на Платформата .',
    p31: '23.	Потрбителят има право да използва Платформата, да запазва части от нея на личен компютър и разпечатва съдържанието му за лични, нетърговски цели.',
    p32: '24.	В случай, че информация публикувана на Платформата е в нарушение на нечии права на интелектуална собственост, моля да се свържете с нас на посочените контакти, за да предприемем необходимите мерки.',
    h4: 'IV.	ОТГОВОРНОСТ',
    p33: '25.	Кей енд Ди Синерджи не носи отговорност пред Потребителя, и/или трети лица, в следните случаи:',
    p34: '25.1.	при загуби, пропуснати ползи и други щети, причинени на Потребителя, или трети лица, в резултат от ползване на услуги чрез Платформата и самата страница от страна на Потребителя, както и за невъзможността да се ползват тези услуги;',
    p35: '25.2.	при неспособност на Потребителя да ползва, и/или тълкува всяка една отделна услуга;',
    p36: '25.3.	при претенции от трети лица срещу Потребителя при, и/или по повод ползване на услугите;',
    p37: '25.4.	ако при нарушения на работоспособността на програмното или техническото осигуряване на други доставчици в Интернет или на електронните съобщителни връзки в и/или извън страната, регистриран Потребител не може да ползва частично или напълно възможностите на услугите, предоставяни на Платформата.',
    h5: 'V.	ЦЕНИ И АНУЛАЦИОННА ПОЛИТИКА',
    p38: '26.	В Платформата има посочени цени в лева.',
    p39: '26.1.	Сумата, която Потребителят заплаща за Услугата е крайна и включва ДДС.',
    p40: '27.	Кей енд Ди Синерджи практикува стриктна анулационна политика и Потербителят следва да има предвид, че: ',
    p41: '27.1.	Кей енд Ди Синерджи ще извърши всичко необходимо за запазване на правата и законните интереси на Потребителите',
    p42: '27.2.	Кей енд Ди Синерджи не носи отговорност по неизпълнение или неточно изпълнение на Общите условия, ако причините за това се дължат на Потребителя, на действия на трето лице несвързано с Общите условия, на невъзможни за предвиждане събития и непреодолими сили от страна на Кей енд Ди Синерджи или негови контрагенти. ',
    p43: '28.	В случай, че Потребителят не е извършил плащане или е нарушил сроковете за заплащане, но не е уведомил Кей енд Ди Синерджи, че няма да ползва Услугата, Кей енд Ди Синерджи има право без съгласието на Потребителя, да анулира Услугата, в който случай Кей енд Ди Синерджи не носи отговорност пред Потребителя и не дължи обезщетения или неустойки. ',
    p44: '29.	В случай, че Потребителят желае да направи промяна по направена от него вече заявка за Услуга, е необходимо, чрез писмена заявка, да се свърже с Кей енд Ди Синерджи възможно най-рано преди датата на стартиране на Услугата, за да изиска необходимите промени.',
    p45: '30.	Кей енд Ди Синерджи си запазва правото да откаже, и/или прекрати заявка за Услуга на който и да е стопанин на домашен любимец, в качеството си на Потребител, в случай, че който и да е регистриран в Платформата ветеринарен лекар, по която и да е причина, преустанови регистрацията си в Платформата. Ако вследствие на невъзможност за отказ, и/или прекряване на заявка за Услугата и нежелание за ползване на Услугата от стопанин на домашен любимец, в качеството си на Потребител, Кей енд Ди Синерджи не е длъжно да върне сумата за Услугата, като подобни претенции се предявяват в писмен вид към Кей енд Ди Синерджи, който подхожда индивидуално. ',
    p46: '30.1.	В случай на несъответствие, и/или спорове, Потребителят следва да се обърне директно към регистрирания в Платфорамта ветеринарен лекар, като за подобна грешка Кей енд Ди Синерджи не носи отговорност и при сигнализация от даден Потребител, и/или ветеринарен лекар, Кей енд Ди Синерджи се задължава да въведе пълната и точна информация.',
    p47: '31.	След заявка и заплащане на Услугата, Потребителя има право да се откаже от Услугата в установения от Закона за защита на потребителите срок, без посочване на причини за това, в срок от 14 (четиринадесет) дни, считано от заплащане на Услугата, като изпрати писмено заявление за отказ от Услугата до “Кей енд Ди Синерджи” ЕООД, ЕИК 206122486, със седалище в гр. София и адрес на управление р-н Младост, ж.к. "Младост 1", бл. 40, вх. А, ет. 6, ап. 21, или като изпрати електронно писмо до електронната поща myepet.passport@gmail.com като в последния случай, Кей енд Ди Синерджи ще изпрати на посочена от Потребителя електронна поща за потвърждение на получаването на отказа.',
    p48: '32.	Когато Потребителят е упражнил правото си на отказ от Услугата от разстояние или от договора извън търговския обект, Кей енд Ди Синерджи възстановява всички суми, получени от потребителя, без неоправдано забавяне и не по-късно от 14 дни, считано от датата, на която е бил уведомен за решението на Потребителя да се откаже от Услугата, като Кей енд Ди Синерджи възстановява получените суми, като използва същото платежно средство, използвано от Потребителя при първоначалната трансакция, освен ако Потребителят е изразил изричното си съгласие за използване на друго платежно средство и при условие че това не е свързано с разходи за Потребителя.',
    p49: '32.1.	В случай, че плащането е направено с банкова карта, възстановяването на суми се извършва, чрез нареждане на обратна операция по картата с която е направено плащането в срок от 7 (седем) дни.',
    p50: '33.	Във всеки случай на отказ на Потребитетля от Услугата, Кей енд Ди Синерджи възстановява сумата за периода, считано от получаване на отказа от Потребителя до изтичане на срока на Услугата.',
    p51: '34.	Платформата предлага на Потребителя, следните възможни видове плащания:',
    p52: '34.1.	Плащане онлайн с банкова карта – Плащането става чрез препратка към онлайн платформа за разплащания, където потребителят извършва плащането предоставяйки на партньора на Кей енд Ди Синерджи своите банкови данни. Кей енд Ди Синерджи не пази и не администрира данните на банковите карти, именно защото самото плащане не се случва на негова, а на партньорска платформа, удостоверена че има право да оперира със съответните данни. ',
    p53: '35.	В случай, че плащането е направено с банкова карта, възстановяването на суми се извършва, чрез нареждане на обратна операция по картата с която е направено плащането в срок от 3 (три) дни.',
    p54: '36.	Кей енд Ди Синерджи потвърждава заявените от Потребителя Услуги чрез имейл. Потребителят се съгласява да получава информация за промоции или новини от сайта Платформата. ',
    p56: '37.	Потребителят има право да се отпише от получаването на новини, чрез линк в получения от него нюзлетър, от своя профил в Платформата или чрез изпращане на лично съобщение до Кей енд Ди Синерджи. ',
    p57: '38.	В случай, че претенциите на Потребителя, свързани с качеството на предоставяната Услуга, не бъдат предявени на място при предоставянето на Услугата, Потребителят има право да предяви надлежно оформена рекламация към Кей енд Ди Синерджи в писмен вид в срок от 14 дни от  заявка за Услугата, в офис на Кей енд Ди Синерджи или чрез изпращане на електронно съобщение до Кей енд Ди Синерджи.',
    p58: '38.1.	Потребителят е длъжен да предостави протокол (рекламация), подписан от представител на ветеринарния лекар и от самия него, посочвайки детайли за своята рекламация и описвайки подробно ситуацията',
    p59: '38.2.	При отсъствие на двустранно подписан протокол или рекламация Потребителят не може да предявява каквито и да е претенции към Кей енд Ди Синерджи.',
    p60: '38.3.	Кей енд Ди Синерджи се задължава да предостави предявените претенции на ветеринарния лекар в срок до един месец от датата на заявка на Услугата, след което да продължи кореспонденцията с Потребителят до решаване на възникналия спор. ',
    p61: '39.	Оригиналната версия на Платформата (на български език) може да бъде преведена и на други езици. В случай на спор относно съдържанието или тълкуванието на някоя преведена версия, то трябва да се има предвид, че оригиналната (българска) версия има превес и надделява относно правата и задълженията на потребителя и компанията. Достъп до българската версия може да има всеки Потребител, избирайки я от горния десен ъгъл на началната страница на Платформата. ',
    h7: 'VI.	ПРОМЯНА НА УСЛОВИЯТА',
    p69: '41.	Кей енд Ди Синерджи си запазва правото едностранно да променя Общите условия, както и структурата на своята Интернет страница, за което се задължава да уведомява Потребителите, чрез публикуване на съобщение на началната страница на Кей енд Ди Синерджи, в 7 (седем) дневен срок, считано от насътпване, и/или от публикуване на промяната на Общите условията.',
    h8: 'VII.	ДРУГИ',
    p70: '42.	Кампании, игри и промоции в Платформата:',
    p71: '42.1.	На Платформата може да има съобщения за състезания, игри и/или промоции, в които Потребителят може да участва, както и препратки към такива инициативи (например във Facebook).',
    p72: '42.2.	Кей енд Ди Синерджи използва предоставената от  Потребителя информация, само в случаите, че Потребителят се е съгласил да участвате в тези инициативи, за да бъде осъществен контакт от Кей енд Ди Синерджи с Потребителя.',
    h9: 'VIII.ЗАКЛЮЧИТЕЛНИ РАЗПОРЕДБИ',
    p73: '43.	За всички неуредени в тези Условия въпроси се прилага действащото в Република България законодателство.',
    p74: '44.	При възникване на спорове страните полагат усилия за доброволното им уреждане по взаимно споразумение. При непостигане на съгласие всяка от страните може да отнесе спора за решаване от компетентен съд.',
    p75: '45.	Общи условия влизат в сила, считано от деня на публикуването им на Платформата.',
    p76: 'За допълнителни въпроси можете да се свържете с нас на посочените в страницата контакти:',
    p77: '“Кей енд Ди Синерджи” ЕООД, ЕИК 206122486, със седалище в гр. София и адрес на управление р-н Младост, ж.к. "Младост 1", бл. 40, вх. А, ет. 6, ап. 21, електронна поща myepet.passport@gmail.com'

  }
}
export default bg;
